/**
 * Segmentierter Hell/Dunkel-Umschalter der Kopfzeile (REQ-20 §4, Entwurf
 * Zeilen 167–174): zwei Knöpfe 28×26px in einer Hülle mit `--surface-2` und
 * Radius `--r`.
 *
 * Der gewählte Zustand steht als `aria-pressed` am jeweiligen Knopf; darüber
 * greift auch die Hervorhebung im Stylesheet.
 */

import type { ReactElement } from 'react';

import { useTheme, type Theme } from '@/hooks/useTheme';

import { darkThemeIcon, lightThemeIcon } from './navIcons';

const ICON_SIZE = 15;

export function ThemeToggle(): ReactElement {
  const { theme, setTheme } = useTheme();

  const button = (value: Theme, title: string, icon: ReactElement): ReactElement => (
    <button
      type="button"
      title={title}
      aria-label={title}
      aria-pressed={theme === value}
      onClick={() => {
        setTheme(value);
      }}
    >
      {icon}
    </button>
  );

  return (
    <div className="iwm-theme-toggle" role="group" aria-label="Darstellung">
      {button('light', 'Hell', lightThemeIcon({ size: ICON_SIZE }))}
      {button('dark', 'Dunkel', darkThemeIcon({ size: ICON_SIZE }))}
    </div>
  );
}

export default ThemeToggle;
